<main class="main main-with-bg" role="main" id="main" tabindex="-1">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="text-center">
                    <h1>{{'deconnexion.title' | translate}}</h1>
                </div>
            </div>
            <div class="col-md-10 col-lg-10">
                <div class="group-col mt-4">
                    <div class="group-col__item">
                        <button type="button" (click)="router.navigate(['/login']);"
                            class=" btn btn--plain btn--primary">{{'deconnexion.button' | translate}}</button>

                        <app-message></app-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
